import React, { useContext, useState, useRef, useEffect } from 'react';
import { Row, Col, Stack } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import 'assets/styles/common.scss';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage, useIntl } from 'react-intl';
import MuiBreadcrumbs from 'components/common/MuiBreadcrumbs';
import { superAdminProvider } from 'routes/AppUrls';
import ReusableTabs from 'components/common/Tabs';
import LabelWithInput from 'components/common/Input/LabelWithInput';
import SelectInput from 'components/common/Input/SelectInput';
import PhoneNumberInput from 'components/common/Input/PhoneNumberInput';
import ProfileIcon from 'assets/images/navbar/profileIcon.png';
import AddBlackColor from 'assets/images/Dashboard/addBlackColor.png';
import crossIcon from 'assets/images/provider/crossIcon.png';
import ReusableButton from 'components/common/Button';
import { addSalonProviderCallAPI } from 'store/SuperAdmin/addSalonProvider/action';
import { useDispatch, useSelector } from 'react-redux';
import ToastNotification from 'components/common/Toast';
import { addCompanyProviderCallAPI } from 'store/SuperAdmin/addCompanyProvider/action';
import CheckValidation from 'utils/Validation';
import { countryCityDropdownCallAPI } from 'store/CountryCityList/action';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { imageUploadCallAPI } from 'store/ImageUpload/action';
import CircularProgress from '@mui/material/CircularProgress';
import Geosuggest from 'react-geosuggest';
import { useLoadScript } from '@react-google-maps/api';
import env from 'utils/environment/env.json';
import { getServiceLocationTypeCallAPI } from 'store/SuperAdmin/serviceLocationType/action';
// import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';
import { FormControl } from '@mui/material';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

const libraries = ['places'];

const AddProvider = () => {
  const navigate = useNavigate();
  const intl = useIntl();
  const dispatch = useDispatch();
  const [conf, setConf] = ToastNotification();
  const { locale } = useContext(LocaleContext);
  const [latLng, setLatLng] = useState({ lat: 28.525377, lng: 77.280106 });

  const [tab, setTab] = useState(1);
  const salonBrandImageFileInputRef = useRef();
  const salonImageRef = useRef();
  const phoneNumberInputRef = useRef(null);
  const alternatePhoneNumberInputRef = useRef(null);
  const bussinessPhoneNumberInputRef = useRef(null);
  const [isError, setIsError] = useState(null);
  const [salonSubmitRole, setSalonSubmitRole] = useState('');
  const [serviceLocationTypeData, setServiceLocationTypeData] = useState([]);

  const [salonBrandImageFile, setSalonBrandImageFile] = useState(null);
  const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(true);
  const [isAlternatePhoneNumberValid, setIsAlternatePhoneNumberValid] =
    useState(true);
  const [isBussinessPhoneNumberValid, setIsBussinessPhoneNumberValid] =
    useState(true);

  const countryCityData = useSelector(
    (state) => state?.countryCityDropdownReducer?.data?.data
  );
  const salonInvitationLoader = useSelector(
    (state) => state?.addSalonProviderReducer?.loading
  );
  const companyInvitationLoader = useSelector(
    (state) => state?.addCompanyProviderReducer?.loading
  );

  const [formValue, setFormValue] = useState({
    serviceLocationType: '',
    ownerName: '',
    postalCode: '',
    bussinessType: [],
    bussinessReview: [],
    searchBussinessName: '',
    addressArea: '',
    country: '',
    city: '',
    phoneNumber: '',
    countryCode: '+974',
    alternatePhoneNumber: '',
    brandImage: '',
    countryCodeAlternateNumber: '+974',
    email: '',
    alternateEmail: '',
    about: '',
    bussinessEmail: '',
    bussinessImages: [],
    countryCodeBussinessPhoneNumber: '+974',
    bussinessPhoneNumber: '',
    averageRating: '',
  });

  //////////////////////////////////////////Open/Close Time //////////////////////////////////
  const [businessHours, setBusinessHours] = useState([
    {
      day_of_week: 'sunday',
      start_time: '00:00',
      end_time: '23:59',
      is_holiday: true,
    },
    {
      day_of_week: 'monday',
      start_time: '00:00',
      end_time: '23:59',
      is_holiday: true,
    },
    {
      day_of_week: 'tuesday',
      start_time: '00:00',
      end_time: '23:59',
      is_holiday: true,
    },
    {
      day_of_week: 'wednesday',
      start_time: '00:00',
      end_time: '23:59',
      is_holiday: true,
    },
    {
      day_of_week: 'thursday',
      start_time: '00:00',
      end_time: '23:59',
      is_holiday: true,
    },
    {
      day_of_week: 'friday',
      start_time: '00:00',
      end_time: '23:59',
      is_holiday: true,
    },
    {
      day_of_week: 'saturday',
      start_time: '00:00',
      end_time: '23:59',
      is_holiday: true,
    },
  ]);

  function strCapitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const handleChangeTime = (event, index) => {
    const list = [...businessHours];
    list[index][event.target.name] = event.target.value;
    setBusinessHours(list);
  };

  const handleChangeTimeHoliday = (event, index) => {
    const list = [...businessHours];
    list[index][event.target.name] = event.target.checked;
    setBusinessHours(list);
  };

  //////////////////////////////////////////Open/Close Time //////////////////////////////////

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: env?.googleApiKey,
    libraries,
  });

  const [formId, setFormId] = useState({
    country: '',
    city: '',
    serviceLocationType: '',
  });

  useEffect(() => {
    getCountryCityList();
    getServiceLocationTypeList();
  }, []);

  const getCountryCityList = () => {
    dispatch(countryCityDropdownCallAPI({}, { naviagte: navigate }));
  };

  const getServiceLocationTypeList = () => {
    dispatch(
      getServiceLocationTypeCallAPI(
        {},
        {
          run: true,
          naviagte: navigate,
          handleFunction: (res) => handleLocationTypeSuccess(res),
        }
      )
    );
  };

  const handleLocationTypeSuccess = (res) => {
    setServiceLocationTypeData(res?.data?.data);
  };

  const tabData = [
    { label: intl.formatMessage({ id: 'Salon' }) },
    { label: intl.formatMessage({ id: 'Company' }) },
  ];

  const [breadcrumbsList, setBreadcrumbsList] = useState([
    {
      title: <FormattedMessage id="Providers" />,
      Link: superAdminProvider(locale),
      isDisbale: false,
    },
    {
      title: <FormattedMessage id="Add a Provider" />,
      Link: '',
      isDisbale: true,
    },
  ]);

  const handleTabChange = (val) => {
    setTab(val);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValue({ ...formValue, [name]: value });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValue({ ...formValue, [name]: value?.name });
    setFormId({ ...formId, [name]: value?.id });
    if (name === 'city') {
      setLatLng({ lat: value?.latitude, lng: value?.longitude });
    }
  };

  const handleSalonBrandImageFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      let formData = new FormData();
      formData.append('filePath', file);
      formData.append('fileType', 'I');
      dispatch(
        imageUploadCallAPI(formData, {
          navigate: navigate,
          run: true,
          handleFunction: (res) => handleSuccess(res),
        })
      );
      setSalonBrandImageFile(URL.createObjectURL(file));
    }
  };

  const handleSuccess = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'success',
    });
    setFormValue({ ...formValue, ['brandImage']: res?.data?.data?.[0]?.id });
  };

  const handleSalonImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      let formData = new FormData();
      formData.append('filePath', file);
      formData.append('fileType', 'I');
      dispatch(
        imageUploadCallAPI(formData, {
          navigate: navigate,
          run: true,
          handleFunction: (res) => handleSalonImagesSuccess(res),
        })
      );
    }
  };

  const handleSalonImagesSuccess = (res) => {
    // setConf({
    //   msg: res?.data?.message,
    //   variant: 'success',
    // });
    setFormValue((prevState) => ({
      ...prevState,
      bussinessImages: [
        ...(prevState?.bussinessImages || []),
        res?.data?.data?.[0],
      ],
    }));
  };

  const handleSalonBrandImageUpload = () => {
    salonBrandImageFileInputRef.current.click();
  };

  const handleSalonImageUpload = () => {
    salonImageRef.current.click();
  };

  const handleDeleteSalonImage = (data, index) => {
    const filterImages = formValue?.bussinessImages?.filter(
      (value) => value !== data
    );

    setFormValue((prevState) => ({
      ...prevState,
      bussinessImages: filterImages,
    }));
  };

  const handleSalonSubmit = (role) => {
    setSalonSubmitRole(role);
    const {
      ownerName,
      serviceLocationType,
      searchBussinessName,
      country,
      city,
      phoneNumber,
      email,
      bussinessEmail,
      bussinessPhoneNumber,
      postalCode,
    } = formValue;
    const error = CheckValidation({
      ownerName,
      serviceLocationType,
      searchBussinessName,
      country,
      city,
      phoneNumber,
      email,
      bussinessEmail,
      bussinessPhoneNumber,
      postalCode,
    });
    setIsError(error);

    if (error.submit && isPhoneNumberValid && isBussinessPhoneNumberValid) {
      if (!formValue?.brandImage) {
        return setConf({
          msg: 'Brand image is required. Please upload a brand image.',
          variant: 'error',
        });
      }

      let body = {
        business_type: 'salon',
        owner_name_en: formValue?.ownerName,
        owner_name_ar: formValue?.ownerName,
        searched_business_name_en: formValue?.searchBussinessName,
        searched_business_name_ar: formValue?.searchBussinessName,
        address: formValue?.addressArea,
        country: formId?.country,
        city: formId?.city,
        contact_number: formValue?.phoneNumber,
        is_contact_verified: false,
        alternate_contact_number: formValue?.alternatePhoneNumber,
        is_alternate_contact_verified: false,
        email: formValue?.email?.toLowerCase(),
        is_email_verified: false,
        alternate_email: formValue?.alternateEmail?.toLowerCase(),
        is_alternate_email_verified: false,
        about_information_en: formValue?.about,
        about_information_ar: formValue?.about,
        profile_photo: formValue?.brandImage,
        bussiness_images:
          formValue?.bussinessImages?.length > 0
            ? formValue?.bussinessImages?.map((item) => item?.id)
            : [],
        about_bussiness: {
          email: formValue?.bussinessEmail?.toLowerCase(),
          contact_number: formValue?.bussinessPhoneNumber,
          business_country_code: formValue?.countryCodeBussinessPhoneNumber,
        },
        email_sent: role === 'invite' ? true : false,
        is_active: true,
        services_location_type: formId?.serviceLocationType,
        opening_closing_holiday: businessHours.map((item) => ({
          ...item,
          start_time: item?.start_time.split(':').slice(0, 2).join(':'),
          end_time: item?.end_time.split(':').slice(0, 2).join(':'),
        })),
        country_code: formValue?.countryCode,
        zip_code: formValue?.postalCode,
        average_rating: formValue?.averageRating,
        review: formValue?.bussinessReview,
      };
      dispatch(
        addSalonProviderCallAPI(body, {
          run: true,
          latlng: latLng,
          handleFunction: (res) => handleRedirect(res),
          navigate: navigate,
          toast: true,
          handleToastError: (res) => handleRedirectError(res),
        })
      );
    }
  };

  const handleCompanySubmit = () => {
    const {
      ownerName,
      searchBussinessName,
      country,
      city,
      phoneNumber,
      email,
      serviceLocationType,
    } = formValue;
    const error = CheckValidation({
      ownerName,
      searchBussinessName,
      country,
      city,
      phoneNumber,
      email,
      serviceLocationType,
    });
    setIsError(error);
    if (error.submit && isPhoneNumberValid) {
      if (!formValue?.brandImage) {
        return setConf({
          msg: 'Brand image is required. Please upload a brand image.',
          variant: 'error',
        });
      }

      let body = {
        business_type: 'company',
        owner_name_en: formValue?.ownerName,
        owner_name_ar: formValue?.ownerName,
        searched_business_name_en: formValue?.searchBussinessName,
        searched_business_name_ar: formValue?.searchBussinessName,
        address: formValue?.addressArea,
        country: formId?.country,
        city: formId?.city,
        contact_number: formValue?.phoneNumber,
        is_contact_verified: false,
        alternate_contact_number: formValue?.alternatePhoneNumber,
        is_alternate_contact_verified: false,
        email: formValue?.email?.toLowerCase(),
        is_email_verified: false,
        alternate_email: formValue?.alternateEmail?.toLowerCase(),
        is_alternate_email_verified: false,
        about_information_en: formValue?.about,
        about_information_ar: formValue?.about,
        profile_photo: formValue?.brandImage,
        bussiness_images:
          formValue?.bussinessImages?.length > 0
            ? formValue?.bussinessImages?.map((item) => item?.id)
            : [],
        services_location_type: formId?.serviceLocationType,
        opening_closing_holiday: businessHours.map((item) => ({
          ...item,
          start_time: item?.start_time.split(':').slice(0, 2).join(':'),
          end_time: item?.end_time.split(':').slice(0, 2).join(':'),
        })),
        country_code: formValue?.countryCode,
        zip_code: formValue?.postalCode,
        average_rating: formValue?.averageRating,
        review: formValue?.bussinessReview,
      };
      dispatch(
        addCompanyProviderCallAPI(body, {
          run: true,
          latlng: latLng,
          handleFunction: (res) => handleRedirect(res),
          navigate: navigate,
          toast: true,
          handleToastError: (res) => handleRedirectError(res),
        })
      );
    }
  };

  const handleRedirect = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'success',
    });
    navigate(superAdminProvider(locale));
  };

  const handleRedirectError = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'error',
    });
  };

  const handleCountryCodeChange = (value, name) => {
    if (name === 'phoneNumber') {
      setFormValue({ ...formValue, countryCode: `+${value}` });
    } else if (name === 'alternatePhoneNumber') {
      setFormValue({ ...formValue, countryCodeAlternateNumber: `+${value}` });
    } else {
      setFormValue({
        ...formValue,
        countryCodeBussinessPhoneNumber: `+${value}`,
      });
    }
  };

  const handlePhoneNumberChange = (e) => {
    const phoneNumberValue = e.target.value.replace(/\D/g, '');
    setFormValue((prev) => ({
      ...prev,
      [e.target.name]: phoneNumberValue,
    }));

    if (e.target.name === 'phoneNumber') {
      const fullPhoneNumber = `${formValue?.countryCode}${phoneNumberValue}`;
      const parsedPhoneNumber = parsePhoneNumberFromString(fullPhoneNumber);
      if (parsedPhoneNumber) {
        setIsPhoneNumberValid(parsedPhoneNumber.isValid());
      } else {
        setIsPhoneNumberValid(false);
      }
    } else if (e.target.name === 'alternatePhoneNumber') {
      const fullPhoneNumber = `${formValue?.countryCodeAlternateNumber}${phoneNumberValue}`;
      const parsedPhoneNumber = parsePhoneNumberFromString(fullPhoneNumber);
      if (parsedPhoneNumber) {
        setIsAlternatePhoneNumberValid(parsedPhoneNumber.isValid());
      } else {
        setIsAlternatePhoneNumberValid(false);
      }
    } else {
      const fullPhoneNumber = `${formValue?.countryCodeBussinessPhoneNumber}${phoneNumberValue}`;
      const parsedPhoneNumber = parsePhoneNumberFromString(fullPhoneNumber);
      if (parsedPhoneNumber) {
        setIsBussinessPhoneNumberValid(parsedPhoneNumber.isValid());
      } else {
        setIsBussinessPhoneNumberValid(false);
      }
    }
  };

  const handleBusinesChanged = (e) => {
    setFormValue((prevState) => ({
      ...prevState,
      ['searchBussinessName']: e,
    }));
  };

  const onSuggestSelect = (suggest) => {
    if (suggest) {
      // Business Name
      setFormValue((prevState) => ({
        ...prevState,
        searchBussinessName: suggest.gmaps.name,
      }));

      ///////////About
      setFormValue((prevState) => ({
        ...prevState,
        about: suggest.description,
      }));

      // Address
      setFormValue((prevState) => ({
        ...prevState,
        addressArea: suggest.gmaps.formatted_address,
      }));

      // AverageRating
      setFormValue((prevState) => ({
        ...prevState,
        averageRating: suggest.gmaps.rating,
      }));

      //ReviewImage Upload

      const ReviewImageUpload = (item, file) => {
        let formData = new FormData();
        formData.append('filePath', file);
        formData.append('fileType', 'U');
        dispatch(
          imageUploadCallAPI(formData, {
            navigate: navigate,
            run: true,
            handleFunction: (res) =>
              handleImageUpoadIdSuccess(item, res?.data?.data?.[0]?.id),
          })
        );
      };

      const handleImageUpoadIdSuccess = (item, imageId) => {
        setFormValue((prevState) => ({
          ...prevState,
          bussinessReview: [
            ...(prevState.bussinessReview || []),
            {
              rating: item?.rating,
              review: item?.text,
              auther_name: item?.author_name,
              rating_images: [imageId],
            },
          ],
        }));
      };
      //ReviewImage Upload

      // Reviews
      suggest?.gmaps?.reviews?.length > 0 &&
        suggest.gmaps.reviews.map((item) =>
          ReviewImageUpload(item, item?.profile_photo_url)
        );

      // Bussiness Types
      setFormValue((prevState) => ({
        ...prevState,
        bussinessType: suggest.gmaps.types,
      }));

      // Country,City Data,postalCode
      const components = suggest.gmaps.address_components;

      let country_name = '';
      let country_id = '';
      let city_name = '';

      for (let key of components) {
        if (key.types[0] === 'country') {
          country_name = key.long_name;
        }
        if (key.types[0] === 'locality') {
          city_name = key.long_name;
        }
        if (key.types[0] === 'postal_code') {
          setFormValue((prevState) => ({
            ...prevState,
            postalCode: key.long_name,
          }));
        }
      }

      if (country_name) {
        let indexCountry = countryCityData.find(
          (obj) => obj.name === country_name
        );

        country_name = indexCountry.name;
        country_id = indexCountry?.id;

        setFormValue((prevState) => ({
          ...prevState,
          country: country_name,
        }));

        setFormId((prevState) => ({
          ...prevState,
          country: country_id,
        }));
      }

      if (country_id) {
        let indexCountry = countryCityData.findIndex(
          (obj) => obj.name === country_name
        );
        let indexCity = countryCityData?.[indexCountry]?.city.find(
          (value) => value?.name === city_name
        );
        setFormValue((prevState) => ({
          ...prevState,
          city: indexCity?.name,
        }));

        setFormId((prevState) => ({
          ...prevState,
          city: indexCity?.id,
        }));
      }

      if (suggest.gmaps.international_phone_number) {
        if (suggest.gmaps.international_phone_number) {
          const phoneDetails = parsePhoneNumberFromString(
            suggest.gmaps.international_phone_number
          );
          if (phoneDetails !== undefined) {
            setFormValue((prevState) => ({
              ...prevState,
              countryCode: `+${phoneDetails.countryCallingCode}`,
            }));

            setFormValue((prevState) => ({
              ...prevState,
              phoneNumber: phoneDetails.nationalNumber,
            }));
          }
        }
      }

      // Lat Long set
      setFormValue((prevState) => ({
        ...prevState,
        latitude: suggest.location.lat,
      }));

      setFormValue((prevState) => ({
        ...prevState,
        longitude: suggest.location.lng,
      }));

      // Business Hours
      const busHours =
        suggest.gmaps.opening_hours && suggest.gmaps.opening_hours.periods;
      const weekdaysHours =
        suggest.gmaps.opening_hours && suggest.gmaps.opening_hours.weekday_text;

      if (busHours && weekdaysHours) {
        let indexKey = 0;
        const list = [...businessHours];

        busHours.forEach((data, index) => {
          list[data.open.day]['start_time'] =
            (data.open.hours.toString().length === 1
              ? '0' + data.open.hours
              : data.open.hours) +
            ':' +
            (data.open.minutes.toString().length === 1
              ? '0' + data.open.minutes
              : data.open.minutes);
          //  +
          // ':00';
          list[data.open.day]['end_time'] =
            (data.close !== undefined &&
            data.close.hours.toString().length === 1
              ? '0' + data.close.hours
              : data.close
                ? data.close.hours
                : '23') +
            ':' +
            (data.close !== undefined &&
            data.close.minutes.toString().length === 1
              ? '0' + data.close.minutes
              : data.close
                ? data.close.minutes
                : '59');
          // +
          // ':00';
          list[data.open.day]['is_holiday'] = false;
        });

        setBusinessHours(list);
      }

      // Photos
      const busPhotos = suggest.gmaps.photos;
      setFormValue((prevState) => ({
        ...prevState,
        bussinessImages: [],
      }));

      if (suggest) {
        busPhotos &&
          busPhotos.length > 0 &&
          busPhotos.forEach((data, index) => {
            let photoUrl = data.getUrl();
            let formData = new FormData();
            formData.append('filePath', photoUrl);
            formData.append('fileType', 'U');
            dispatch(
              imageUploadCallAPI(formData, {
                navigate: navigate,
                run: true,
                handleFunction: (res) => handleSalonImagesSuccess(res),
              })
            );
          });
      }
    }
  };

  return (
    <Row className="bc-F2F3F6 m-0 p-0">
      <Col
        className={
          locale === 'en'
            ? 'commonEnContainer lg:ml-left'
            : 'commonArContainer lg:mr-right'
        }
      >
        <MuiBreadcrumbs size="14" list={breadcrumbsList} />
        <Row className="bc-FFFFFF m-0 p-16 mt-3">
          <h2 className="fc-292D32 fs-32 fw-400 ff-Akkurat_Bold m-0">
            <FormattedMessage id="Provider Details" />
          </h2>

          <h5 className="fc-292D32 fs-18 fw-400 ff-Akkurat_Bold m-0 mt-4">
            <FormattedMessage id="Business Details" />
          </h5>

          <p className="fc-292D32 fs-14 fw-400 ff-Akkurat m-0 mt-3">
            <FormattedMessage id="Business Type" />
          </p>

          <Col md={12} lg={6} xl={6} xxl={4} className="mt-2">
            <ReusableTabs
              tabs={tabData}
              defaultTab={1}
              currentTab={(val) => handleTabChange(val)}
              hasBorder={'#DDDDDD'}
            />
          </Col>

          {tab === 1 && (
            <>
              <Row className="m-0 p-0">
                <Col xs={12} md={6}>
                  <Row className="m-0 p-0">
                    <Col xs={12} md={12} className="mt-3">
                      <SelectInput
                        label={<FormattedMessage id="Service Location Type " />}
                        required={true}
                        placeholder={intl.formatMessage({
                          id: 'Service Location Type ',
                        })}
                        name={'serviceLocationType'}
                        value={formValue?.serviceLocationType}
                        data={serviceLocationTypeData}
                        onChange={(e) => handleInputChange(e)}
                        errorText={
                          isError &&
                          isError?.serviceLocationType?.error &&
                          isError?.serviceLocationType?.errorMessage
                        }
                      />
                    </Col>

                    <Col xs={12} md={6} className="mt-3">
                      <LabelWithInput
                        label={<FormattedMessage id="Owner Name" />}
                        required={true}
                        placeholder={intl.formatMessage({ id: 'Owner Name' })}
                        name="ownerName"
                        type="text"
                        value={formValue?.ownerName}
                        onChange={handleChange}
                        errorText={
                          isError &&
                          isError.ownerName.error &&
                          isError.ownerName.errorMessage
                        }
                      />
                    </Col>

                    <Col xs={12} md={6} className="mt-3">
                      <LabelWithInput
                        label={<FormattedMessage id="Postal Code" />}
                        required={true}
                        placeholder={intl.formatMessage({ id: 'Postal Code' })}
                        name="postalCode"
                        type="text"
                        value={formValue?.postalCode}
                        onChange={handleChange}
                        errorText={
                          isError &&
                          isError.postalCode.error &&
                          isError.postalCode.errorMessage
                        }
                      />
                    </Col>

                    <Col xs={12} md={12} className="mt-3">
                      <LabelWithInput
                        label={
                          <FormattedMessage id="Address of the serving area" />
                        }
                        placeholder={intl.formatMessage({
                          id: 'Address of the serving area',
                        })}
                        name="addressArea"
                        type="text"
                        value={formValue?.addressArea}
                        onChange={handleChange}
                      />
                    </Col>

                    <Col xs={12} md={6} className="mt-3">
                      <SelectInput
                        label={<FormattedMessage id="Country" />}
                        required={true}
                        placeholder={intl.formatMessage({ id: 'Country' })}
                        name={'country'}
                        value={formValue?.country}
                        data={countryCityData}
                        onChange={(e) => handleInputChange(e)}
                        errorText={
                          isError &&
                          isError.country.error &&
                          isError.country.errorMessage
                        }
                      />
                    </Col>

                    <Col xs={12} md={6} className="mt-3">
                      <SelectInput
                        label={<FormattedMessage id="City" />}
                        required={true}
                        placeholder={intl.formatMessage({ id: 'City' })}
                        name={'city'}
                        value={formValue?.city}
                        data={
                          countryCityData?.find(
                            (value) => value?.name === formValue?.country
                          )?.city || []
                        }
                        onChange={(e) => handleInputChange(e)}
                        errorText={
                          isError &&
                          isError.city.error &&
                          isError.city.errorMessage
                        }
                      />
                    </Col>

                    <Col xs={12} md={12} className="mt-3">
                      <PhoneNumberInput
                        label={<FormattedMessage id="Contact Number" />}
                        country={'qa'}
                        required={true}
                        value={formValue?.countryCode}
                        name={'phoneNumber'}
                        onCountryCodeChange={(e) =>
                          handleCountryCodeChange(e, 'phoneNumber')
                        }
                        onPhoneNumberChange={handlePhoneNumberChange}
                        phoneNumber={formValue.phoneNumber}
                        phoneNumberRef={phoneNumberInputRef}
                        isPhoneNumberValid={isPhoneNumberValid}
                        isError={
                          isError &&
                          isError.phoneNumber.error &&
                          isError.phoneNumber.errorMessage
                        }
                        errorMessage="Invalid phone number for selected country code"
                      />
                    </Col>

                    <Col xs={12} md={12} className="mt-3">
                      <LabelWithInput
                        label={<FormattedMessage id="Email ID" />}
                        required={true}
                        placeholder={intl.formatMessage({ id: 'Email ID' })}
                        name="email"
                        type="text"
                        value={formValue?.email}
                        onChange={handleChange}
                        errorText={
                          isError &&
                          isError.email.error &&
                          isError.email.errorMessage
                        }
                      />
                    </Col>
                  </Row>
                </Col>

                <Col xs={12} md={6}>
                  <Row className="m-0 p-0">
                    <Col xs={12} md={12}>
                      {isLoaded && (
                        <>
                          <p className="businessLabel">
                            <FormattedMessage id="Search business name" />
                            <span style={{ color: 'red' }}> *</span>
                          </p>
                          <div className="geosuggestInput">
                            <Geosuggest
                              onChange={(e) => handleBusinesChanged(e)}
                              onSuggestSelect={onSuggestSelect}
                              initialValue={formValue?.searchBussinessName}
                              placeholder={intl.formatMessage({
                                id: 'Search business name',
                              })}
                              types={['establishment']}
                              country={['IN', 'SA']}
                            />
                            {isError &&
                              isError.searchBussinessName?.error &&
                              isError.searchBussinessName?.errorMessage && (
                                <div className="error-message">
                                  {isError.searchBussinessName.errorMessage}
                                </div>
                              )}
                          </div>
                        </>
                      )}
                    </Col>

                    <Col xs={12} md={12}>
                      <p className="businessLabel">
                        <FormattedMessage id="Opening/Closing Time" />
                      </p>
                      <div className="table_content">
                        <Row className="table_content_header">
                          <Col xs={2} className="text-center">
                            Day
                          </Col>
                          <Col xs={4} className="text-center">
                            Opening
                          </Col>
                          <Col xs={4} className="text-center">
                            Closing
                          </Col>
                          <Col xs={2} className="text-center">
                            Closed
                          </Col>
                        </Row>
                        <div className="table_content_body">
                          {businessHours &&
                            businessHours.map((data, index) => {
                              return (
                                <Row className="table_content_data">
                                  <Col
                                    xs={2}
                                    className="table_content_day text-center"
                                  >
                                    {strCapitalize(
                                      data.day_of_week.substring(0, 3)
                                    )}
                                  </Col>
                                  <Col
                                    xs={4}
                                    className="bg-colored text-center TimePicker"
                                  >
                                    <span>
                                      <FormControl
                                        sx={{ m: 1, minWidth: 'auto' }}
                                        className="input_picker flex-row"
                                      >
                                        <input
                                          name="start_time"
                                          className="inputTime"
                                          type="time"
                                          step="2"
                                          id="appt"
                                          placeholder="00:00:00"
                                          defaultValue={data.start_time}
                                          value={data.start_time}
                                          onChange={(e) =>
                                            handleChangeTime(e, index)
                                          }
                                        />
                                      </FormControl>
                                    </span>
                                  </Col>
                                  <Col
                                    xs={4}
                                    className="bg-colored text-center TimePicker"
                                  >
                                    <span>
                                      <FormControl
                                        sx={{ m: 1, minWidth: 'auto' }}
                                        className="input_picker flex-row"
                                      >
                                        <input
                                          name="end_time"
                                          className="inputTime"
                                          type="time"
                                          step="2"
                                          id="appt"
                                          placeholder="00:00:00"
                                          defaultValue={data.end_time}
                                          value={data.end_time}
                                          onChange={(e) =>
                                            handleChangeTime(e, index)
                                          }
                                        />
                                      </FormControl>
                                    </span>
                                  </Col>
                                  <Col
                                    xs={2}
                                    className="items-center justify-center text-center checkb"
                                  >
                                    <input
                                      type="checkbox"
                                      name="is_holiday"
                                      defaultChecked={data.is_holiday}
                                      checked={data.is_holiday}
                                      className="cursor-pointer"
                                      onChange={(e) =>
                                        handleChangeTimeHoliday(e, index)
                                      }
                                    />
                                  </Col>
                                </Row>
                              );
                            })}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>

                <Col xs={12} md={12} className="mt-3">
                  <LabelWithInput
                    label={<FormattedMessage id="About/Information" />}
                    placeholder={intl.formatMessage({
                      id: 'About/Information',
                    })}
                    height="100"
                    multiline
                    name="about"
                    value={formValue?.about}
                    onChange={(e) => handleChange(e)}
                  />
                </Col>

                <input
                  ref={salonBrandImageFileInputRef}
                  type="file"
                  accept=".png, .jpg, .jpeg"
                  disabled={false}
                  style={{ display: 'none' }}
                  onChange={handleSalonBrandImageFileChange}
                />

                <div className="mt-4">
                  <p className="p-0 m-0 fs-18 fc-292D32 fw-400 ff-Akkurat_Bold">
                    <FormattedMessage id="Photos" />{' '}
                    <span
                      style={{
                        color: 'red',
                        fontSize: '14px',
                      }}
                    >
                      *
                    </span>
                  </p>
                  <Stack
                    direction="horizontal"
                    gap={4}
                    className="items-center mt-4"
                  >
                    <div className="AvtarImageIcon">
                      {salonBrandImageFile && (
                        <img
                          src={salonBrandImageFile}
                          alt={'icon'}
                          style={{
                            height: '88px',
                            width: '88px',
                            borderRadius: '50%',
                          }}
                        />
                      )}
                      <img
                        src={ProfileIcon}
                        alt="icon"
                        style={{ height: '32px', width: '32px' }}
                        className="profileIcon"
                        onClick={handleSalonBrandImageUpload}
                      />
                    </div>
                    <div>
                      <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat_Bold">
                        <FormattedMessage id="Upload Brand Image" />
                      </p>
                      <p className="p-0 m-0 fs-14 fc-9A9A9A fw-400 ff-Akkurat">
                        <FormattedMessage id="A picture will help people recognize you" />
                      </p>
                    </div>
                  </Stack>
                </div>

                <Col xs={12} md={12} className="mt-3">
                  <div className="flex justify-between items-center">
                    <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                      <FormattedMessage id="Images" />
                    </p>
                    {formValue?.bussinessImages?.length > 0 && (
                      <ReusableButton
                        fullWidth={false}
                        variant="outlined"
                        color="#292D32"
                        fontSize="16px"
                        fontWeight="400"
                        padding="12px 25px"
                        height="44px"
                        bgColor="transparent"
                        fontFamily="Akkurat"
                        onClick={handleSalonImageUpload}
                      >
                        <img
                          src={AddBlackColor}
                          alt="icon"
                          style={{ height: '24px', width: '24px' }}
                          className="me-2"
                        />
                        <FormattedMessage id="Add Images" />
                      </ReusableButton>
                    )}
                  </div>

                  <input
                    ref={salonImageRef}
                    type="file"
                    accept=".png, .jpg, .jpeg"
                    disabled={false}
                    style={{ display: 'none' }}
                    onChange={handleSalonImageChange}
                  />

                  {formValue?.bussinessImages?.length <= 0 ? (
                    <div className="mt-2 bussinessImages flex justify-center align-center">
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center cursor-pointer"
                        onClick={handleSalonImageUpload}
                      >
                        <img
                          src={AddBlackColor}
                          alt="icon"
                          style={{ height: '24px', width: '24px' }}
                        />
                        <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat_Bold">
                          <FormattedMessage id="AddImageEn" />
                        </p>
                      </Stack>
                    </div>
                  ) : (
                    <div className="flex flex-wrap gap-2 mt-3">
                      {formValue?.bussinessImages.map((key, index) => (
                        <div className="relative">
                          <img
                            key={index}
                            src={key?.filePath}
                            alt="image"
                            style={{ height: '122px', width: '246px' }}
                          />
                          <img
                            src={crossIcon}
                            alt="icon"
                            style={{ height: '24px', width: '24px' }}
                            className="absolute top-2 right-2 cursor-pointer"
                            onClick={() => handleDeleteSalonImage(key, index)}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </Col>

                <Col xs={12} md={12} className="mt-3">
                  <p className="m-0 p-0 mt-4 fs-18 fc-292D32 fw-400 ff-Akkurat_Bold">
                    <FormattedMessage id="About Business" />
                  </p>
                </Col>

                <Col xs={12} md={6} className="mt-1">
                  <LabelWithInput
                    label={<FormattedMessage id="Email" />}
                    required={true}
                    placeholder={intl.formatMessage({ id: 'Email' })}
                    name="bussinessEmail"
                    type="text"
                    value={formValue?.bussinessEmail}
                    onChange={handleChange}
                    errorText={
                      isError &&
                      isError.bussinessEmail.error &&
                      isError.bussinessEmail.errorMessage
                    }
                  />
                </Col>

                <Col xs={12} md={6} className="mt-1">
                  <PhoneNumberInput
                    label={<FormattedMessage id="Contact Number" />}
                    required={true}
                    country={'qa'}
                    value={formValue?.countryCodeBussinessPhoneNumber}
                    name={'bussinessPhoneNumber'}
                    onCountryCodeChange={(e) =>
                      handleCountryCodeChange(e, 'bussinessPhoneNumber')
                    }
                    onPhoneNumberChange={handlePhoneNumberChange}
                    phoneNumber={formValue.bussinessPhoneNumber}
                    phoneNumberRef={bussinessPhoneNumberInputRef}
                    isPhoneNumberValid={isBussinessPhoneNumberValid}
                    isError={
                      isError &&
                      isError.bussinessPhoneNumber.error &&
                      isError.bussinessPhoneNumber.errorMessage
                    }
                    errorMessage="Invalid phone number for selected country code"
                  />
                </Col>
              </Row>

              <Row className="mt-4 items-end m-0 p-0">
                <div className="flex justify-end">
                  <Stack
                    direction="horizontal"
                    gap={3}
                    className="items-center"
                  >
                    <ReusableButton
                      fullWidth={false}
                      variant="outlined"
                      color="#292D32"
                      fontSize="16px"
                      fontWeight="400"
                      padding="12px 25px"
                      height="44px"
                      bgColor="transparent"
                      fontFamily="Akkurat"
                      onClick={() => navigate(superAdminProvider(locale))}
                    >
                      <FormattedMessage id="Cancel" />
                    </ReusableButton>

                    <ReusableButton
                      fullWidth={false}
                      variant="contained"
                      color="#F5F5F5"
                      fontSize="16px"
                      fontWeight="400"
                      padding="12px 25px"
                      height="44px"
                      bgColor="#292D32"
                      fontFamily="Akkurat"
                      endIcon={
                        salonInvitationLoader &&
                        salonSubmitRole === 'invite' && (
                          <CircularProgress
                            style={{
                              color: 'white',
                              width: '20px',
                              height: '20px',
                            }}
                          />
                        )
                      }
                      onClick={() => handleSalonSubmit('invite')}
                    >
                      <FormattedMessage id="Send Invitation" />
                    </ReusableButton>

                    <ReusableButton
                      fullWidth={false}
                      variant="contained"
                      color="#F5F5F5"
                      fontSize="16px"
                      fontWeight="400"
                      padding="12px 25px"
                      height="44px"
                      bgColor="#292D32"
                      fontFamily="Akkurat"
                      endIcon={
                        salonInvitationLoader &&
                        salonSubmitRole === 'save' && (
                          <CircularProgress
                            style={{
                              color: 'white',
                              width: '20px',
                              height: '20px',
                            }}
                          />
                        )
                      }
                      onClick={() => handleSalonSubmit('save')}
                    >
                      <FormattedMessage id="Save" />
                    </ReusableButton>
                  </Stack>
                </div>
              </Row>
            </>
          )}

          {tab === 2 && (
            <>
              <Row className="m-0 p-0">
                <Col xs={12} md={6}>
                  <Row className="m-0 p-0">
                    <Col xs={12} md={12} className="mt-3">
                      <SelectInput
                        label={<FormattedMessage id="Service Location Type " />}
                        required={true}
                        placeholder={intl.formatMessage({
                          id: 'Service Location Type ',
                        })}
                        name={'serviceLocationType'}
                        value={formValue?.serviceLocationType}
                        data={serviceLocationTypeData}
                        onChange={(e) => handleInputChange(e)}
                        errorText={
                          isError &&
                          isError?.serviceLocationType?.error &&
                          isError?.serviceLocationType?.errorMessage
                        }
                      />
                    </Col>

                    <Col xs={12} md={6} className="mt-3">
                      <LabelWithInput
                        label={<FormattedMessage id="Owner Name" />}
                        required={true}
                        placeholder={intl.formatMessage({ id: 'Owner Name' })}
                        name="ownerName"
                        type="text"
                        value={formValue?.ownerName}
                        onChange={handleChange}
                        errorText={
                          isError &&
                          isError.ownerName.error &&
                          isError.ownerName.errorMessage
                        }
                      />
                    </Col>

                    <Col xs={12} md={6} className="mt-3">
                      <LabelWithInput
                        label={<FormattedMessage id="Postal Code" />}
                        required={true}
                        placeholder={intl.formatMessage({ id: 'Postal Code' })}
                        name="postalCode"
                        type="text"
                        value={formValue?.postalCode}
                        onChange={handleChange}
                        errorText={
                          isError &&
                          isError.postalCode.error &&
                          isError.postalCode.errorMessage
                        }
                      />
                    </Col>

                    <Col xs={12} md={12} className="mt-3">
                      <LabelWithInput
                        label={
                          <FormattedMessage id="Address of the serving area" />
                        }
                        placeholder={intl.formatMessage({
                          id: 'Address of the serving area',
                        })}
                        name="addressArea"
                        type="text"
                        value={formValue?.addressArea}
                        onChange={handleChange}
                      />
                    </Col>

                    <Col xs={12} md={6} className="mt-3">
                      <SelectInput
                        label={<FormattedMessage id="Country" />}
                        required={true}
                        placeholder={intl.formatMessage({ id: 'Country' })}
                        name={'country'}
                        value={formValue?.country}
                        data={countryCityData}
                        onChange={(e) => handleInputChange(e)}
                        errorText={
                          isError &&
                          isError.country.error &&
                          isError.country.errorMessage
                        }
                      />
                    </Col>

                    <Col xs={12} md={6} className="mt-3">
                      <SelectInput
                        label={<FormattedMessage id="City" />}
                        required={true}
                        placeholder={intl.formatMessage({ id: 'City' })}
                        name={'city'}
                        value={formValue?.city}
                        data={
                          countryCityData?.find(
                            (value) => value?.name === formValue?.country
                          )?.city || []
                        }
                        onChange={(e) => handleInputChange(e)}
                        errorText={
                          isError &&
                          isError.city.error &&
                          isError.city.errorMessage
                        }
                      />
                    </Col>

                    <Col xs={12} md={12} className="mt-3">
                      <PhoneNumberInput
                        label={<FormattedMessage id="Contact Number" />}
                        required={true}
                        country={'qa'}
                        value={formValue?.countryCode}
                        name={'phoneNumber'}
                        onCountryCodeChange={(e) =>
                          handleCountryCodeChange(e, 'phoneNumber')
                        }
                        onPhoneNumberChange={handlePhoneNumberChange}
                        phoneNumber={formValue.phoneNumber}
                        phoneNumberRef={phoneNumberInputRef}
                        isPhoneNumberValid={isPhoneNumberValid}
                        isError={
                          isError &&
                          isError.phoneNumber.error &&
                          isError.phoneNumber.errorMessage
                        }
                        errorMessage="Invalid phone number for selected country code"
                      />
                    </Col>

                    <Col xs={12} md={12} className="mt-3">
                      <LabelWithInput
                        label={<FormattedMessage id="Email ID" />}
                        required={true}
                        placeholder={intl.formatMessage({ id: 'Email ID' })}
                        name="email"
                        type="text"
                        value={formValue?.email}
                        onChange={handleChange}
                        errorText={
                          isError &&
                          isError.email.error &&
                          isError.email.errorMessage
                        }
                      />
                    </Col>
                  </Row>
                </Col>

                <Col xs={12} md={6}>
                  <Row className="m-0 p-0">
                    <Col xs={12} md={12}>
                      {isLoaded && (
                        <>
                          <p className="businessLabel">
                            <FormattedMessage id="Search business name" />
                            <span style={{ color: 'red' }}> *</span>
                          </p>
                          <div className="geosuggestInput">
                            <Geosuggest
                              onChange={(e) => handleBusinesChanged(e)}
                              // onUpdateSuggests={onUpdateSuggests}
                              onSuggestSelect={onSuggestSelect}
                              initialValue={formValue?.searchBussinessName}
                              placeholder={intl.formatMessage({
                                id: 'Search business name',
                              })}
                              types={['establishment']}
                              country={['IN', 'SA']}
                            />
                            {isError &&
                              isError.searchBussinessName?.error &&
                              isError.searchBussinessName?.errorMessage && (
                                <div className="error-message">
                                  {isError.searchBussinessName.errorMessage}
                                </div>
                              )}
                          </div>
                        </>
                      )}
                    </Col>

                    <Col xs={12} md={12}>
                      <p className="businessLabel">
                        <FormattedMessage id="Opening/Closing Time" />
                      </p>
                      <div className="table_content">
                        <Row className="table_content_header">
                          <Col xs={2} className="text-center">
                            Day
                          </Col>
                          <Col xs={4} className="text-center">
                            Opening
                          </Col>
                          <Col xs={4} className="text-center">
                            Closing
                          </Col>
                          <Col xs={2} className="text-center">
                            Closed
                          </Col>
                        </Row>
                        <div className="table_content_body">
                          {businessHours &&
                            businessHours.map((data, index) => {
                              return (
                                <Row className="table_content_data">
                                  <Col
                                    xs={2}
                                    className="table_content_day text-center"
                                  >
                                    {strCapitalize(
                                      data.day_of_week.substring(0, 3)
                                    )}
                                  </Col>
                                  <Col
                                    xs={4}
                                    className="bg-colored text-center TimePicker"
                                  >
                                    <span>
                                      <FormControl
                                        sx={{ m: 1, minWidth: 'auto' }}
                                        className="input_picker flex-row"
                                      >
                                        <input
                                          name="start_time"
                                          className="inputTime"
                                          type="time"
                                          step="2"
                                          id="appt"
                                          placeholder="00:00:00"
                                          defaultValue={data.start_time}
                                          value={data.start_time}
                                          onChange={(e) =>
                                            handleChangeTime(e, index)
                                          }
                                        />
                                      </FormControl>
                                    </span>
                                  </Col>
                                  <Col
                                    xs={4}
                                    className="bg-colored text-center TimePicker"
                                  >
                                    <span>
                                      <FormControl
                                        sx={{ m: 1, minWidth: 'auto' }}
                                        className="input_picker flex-row"
                                      >
                                        <input
                                          name="end_time"
                                          className="inputTime"
                                          type="time"
                                          step="2"
                                          id="appt"
                                          placeholder="00:00:00"
                                          defaultValue={data.end_time}
                                          value={data.end_time}
                                          onChange={(e) =>
                                            handleChangeTime(e, index)
                                          }
                                        />
                                      </FormControl>
                                    </span>
                                  </Col>
                                  <Col
                                    xs={2}
                                    className="items-center justify-center text-center checkb"
                                  >
                                    <input
                                      type="checkbox"
                                      name="is_holiday"
                                      defaultChecked={data.is_holiday}
                                      checked={data.is_holiday}
                                      className="cursor-pointer"
                                      onChange={(e) =>
                                        handleChangeTimeHoliday(e, index)
                                      }
                                    />
                                  </Col>
                                </Row>
                              );
                            })}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>

                <Col xs={12} md={12} className="mt-3">
                  <LabelWithInput
                    label={<FormattedMessage id="About/Information" />}
                    placeholder={intl.formatMessage({
                      id: 'About/Information',
                    })}
                    height="100"
                    multiline
                    name="about"
                    value={formValue?.about}
                    onChange={(e) => handleChange(e)}
                  />
                </Col>

                <input
                  ref={salonBrandImageFileInputRef}
                  type="file"
                  accept=".png, .jpg, .jpeg"
                  disabled={false}
                  style={{ display: 'none' }}
                  onChange={handleSalonBrandImageFileChange}
                />

                <div className="mt-4">
                  <p className="p-0 m-0 fs-18 fc-292D32 fw-400 ff-Akkurat_Bold">
                    <FormattedMessage id="Photos" />{' '}
                    <span
                      style={{
                        color: 'red',
                        fontSize: '14px',
                      }}
                    >
                      *
                    </span>
                  </p>
                  <Stack
                    direction="horizontal"
                    gap={4}
                    className="items-center mt-4"
                  >
                    <div className="AvtarImageIcon">
                      {salonBrandImageFile && (
                        <img
                          src={salonBrandImageFile}
                          alt={'icon'}
                          style={{
                            height: '88px',
                            width: '88px',
                            borderRadius: '50%',
                          }}
                        />
                      )}
                      <img
                        src={ProfileIcon}
                        alt="icon"
                        style={{ height: '32px', width: '32px' }}
                        className="profileIcon"
                        onClick={handleSalonBrandImageUpload}
                      />
                    </div>
                    <div>
                      <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat_Bold">
                        <FormattedMessage id="Upload Brand Image" />
                      </p>
                      <p className="p-0 m-0 fs-14 fc-9A9A9A fw-400 ff-Akkurat">
                        <FormattedMessage id="A picture will help people recognize you" />
                      </p>
                    </div>
                  </Stack>
                </div>

                <Col xs={12} md={12} className="mt-3">
                  <div className="flex justify-between items-center">
                    <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                      <FormattedMessage id="Images" />
                    </p>
                    {formValue?.bussinessImages?.length > 0 && (
                      <ReusableButton
                        fullWidth={false}
                        variant="outlined"
                        color="#292D32"
                        fontSize="16px"
                        fontWeight="400"
                        padding="12px 25px"
                        height="44px"
                        bgColor="transparent"
                        fontFamily="Akkurat"
                        onClick={handleSalonImageUpload}
                      >
                        <img
                          src={AddBlackColor}
                          alt="icon"
                          style={{ height: '24px', width: '24px' }}
                          className="me-2"
                        />
                        <FormattedMessage id="Add Images" />
                      </ReusableButton>
                    )}
                  </div>

                  <input
                    ref={salonImageRef}
                    type="file"
                    accept=".png, .jpg, .jpeg"
                    disabled={false}
                    style={{ display: 'none' }}
                    onChange={handleSalonImageChange}
                  />

                  {formValue?.bussinessImages?.length <= 0 ? (
                    <div className="mt-2 bussinessImages flex justify-center align-center">
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center cursor-pointer"
                        onClick={handleSalonImageUpload}
                      >
                        <img
                          src={AddBlackColor}
                          alt="icon"
                          style={{ height: '24px', width: '24px' }}
                        />
                        <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat_Bold">
                          <FormattedMessage id="AddImageEn" />
                        </p>
                      </Stack>
                    </div>
                  ) : (
                    <div className="flex flex-wrap gap-2 mt-3">
                      {formValue?.bussinessImages.map((key, index) => (
                        <div className="relative">
                          <img
                            src={key?.filePath}
                            alt="image"
                            style={{ height: '122px', width: '246px' }}
                          />
                          <img
                            src={crossIcon}
                            alt="icon"
                            style={{ height: '24px', width: '24px' }}
                            className="absolute top-2 right-2 cursor-pointer"
                            onClick={() => handleDeleteSalonImage(key, index)}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </Col>
              </Row>

              <Row className="mt-4 items-end m-0 p-0">
                <div className="flex justify-end">
                  <Stack
                    direction="horizontal"
                    gap={3}
                    className="items-center"
                  >
                    <ReusableButton
                      fullWidth={false}
                      variant="outlined"
                      color="#292D32"
                      fontSize="16px"
                      fontWeight="400"
                      padding="12px 25px"
                      height="44px"
                      bgColor="transparent"
                      fontFamily="Akkurat"
                      onClick={() => navigate(superAdminProvider(locale))}
                    >
                      <FormattedMessage id="Cancel" />
                    </ReusableButton>

                    <ReusableButton
                      fullWidth={false}
                      variant="contained"
                      color="#F5F5F5"
                      fontSize="16px"
                      fontWeight="400"
                      padding="12px 25px"
                      height="44px"
                      bgColor="#292D32"
                      fontFamily="Akkurat"
                      endIcon={
                        companyInvitationLoader && (
                          <CircularProgress
                            style={{
                              color: 'white',
                              width: '20px',
                              height: '20px',
                            }}
                          />
                        )
                      }
                      onClick={() => handleCompanySubmit()}
                    >
                      <FormattedMessage id="Send Invitation" />
                    </ReusableButton>
                  </Stack>
                </div>
              </Row>
            </>
          )}
        </Row>
      </Col>
    </Row>
  );
};

export default AddProvider;
